export default "__VITE_ASSET__D702NLhH__"